import pickBy from 'lodash/pickBy';
import { API } from '../api';
import * as types from '../constants/actions';
import { getState } from '../helpers';
import { ACTION_STATUS as STATUS, STATE } from '../constants';
import { logActionError } from '../helpers/logger';

const fetchIdeaStatus = payload => ({
  type: types.FETCH_IDEA,
  payload,
});

export const fetchIdea = uuid => async dispatch => {
  try {
    dispatch(fetchIdeaStatus({ status: STATUS.REQUEST }));

    const { data } = await API.ideas.fetchIdea(uuid);

    dispatch(fetchIdeaStatus({ status: STATUS.SUCCESS, data }));
  } catch (error) {
    dispatch(fetchIdeaStatus({ status: STATUS.FAILURE }));
    logActionError(types.FETCH_IDEA, error);
  }
};

const fetchIdeaStatsStatus = payload => ({
  type: types.FETCH_IDEA_STATS,
  payload,
});

export const fetchIdeaStats = uuid => async dispatch => {
  try {
    dispatch(fetchIdeaStatsStatus({ status: STATUS.REQUEST }));

    const { data } = await API.ideas.fetchIdeaStats(uuid);

    if (data.projects) {
      data.projects = data.projects.filter(({ status }) => status === 'publish');
    }

    dispatch(fetchIdeaStatsStatus({ status: STATUS.SUCCESS, data: { ...data, ideaUUID: uuid } }));
  } catch (error) {
    dispatch(fetchIdeaStatsStatus({ status: STATUS.FAILURE, data: { builders: [], projects: [], ideaUUID: uuid } }));
    logActionError(types.FETCH_IDEA_STATS, error);
  }
};

const submitIdeaStatus = payload => ({
  type: types.SUBMIT_IDEA,
  payload,
});

export const submitIdea = ideaObj => async dispatch => {
  try {
    const { username } = getState(STATE.AUTHENTICATION);
    const filteredIdea = pickBy(ideaObj, x => !!x.trim());
    dispatch(submitIdeaStatus({ status: STATUS.REQUEST }));

    await API.ideas.submitIdea(username, filteredIdea);

    dispatch(submitIdeaStatus({ status: STATUS.SUCCESS }));
  } catch (error) {
    dispatch(submitIdeaStatus({ status: STATUS.FAILURE }));
    logActionError(types.SUBMIT_IDEA, error);
  }
};
